'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList(cursor, epsCodeSearch) {
  this.Lapp_pages_AppPage$OutOfStockMedicationReportsSentList__f_cursor = null;
  this.Lapp_pages_AppPage$OutOfStockMedicationReportsSentList__f_epsCodeSearch = null;
  this.Lapp_pages_AppPage$OutOfStockMedicationReportsSentList__f_cursor = cursor;
  this.Lapp_pages_AppPage$OutOfStockMedicationReportsSentList__f_epsCodeSearch = epsCodeSearch;
}
export { $c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList as $c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList };
$c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList.prototype.constructor = $c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList;
/** @constructor */
function $h_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList() {
}
export { $h_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList as $h_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList };
$h_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList.prototype = $c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList.prototype;
$c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1150669368, true);
});
$c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList)) {
    var x = this.Lapp_pages_AppPage$OutOfStockMedicationReportsSentList__f_cursor;
    var x$2 = x$0.Lapp_pages_AppPage$OutOfStockMedicationReportsSentList__f_cursor;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lapp_pages_AppPage$OutOfStockMedicationReportsSentList__f_epsCodeSearch;
      var x$4 = x$0.Lapp_pages_AppPage$OutOfStockMedicationReportsSentList__f_epsCodeSearch;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList.prototype.productPrefix__T = (function() {
  return "OutOfStockMedicationReportsSentList";
});
$c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_pages_AppPage$OutOfStockMedicationReportsSentList__f_cursor;
  }
  if ((n === 1)) {
    return this.Lapp_pages_AppPage$OutOfStockMedicationReportsSentList__f_epsCodeSearch;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "cursor";
  }
  if ((n === 1)) {
    return "epsCodeSearch";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_pages_AppPage$OutOfStockMedicationReportsSentList)));
}
export { $isArrayOf_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList as $isArrayOf_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList };
var $d_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList, "app.pages.AppPage$OutOfStockMedicationReportsSentList", ({
  Lapp_pages_AppPage$OutOfStockMedicationReportsSentList: 1,
  Lapp_pages_AppPage: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList as $d_Lapp_pages_AppPage$OutOfStockMedicationReportsSentList };
//# sourceMappingURL=app.pages.-App-Page$-Out-Of-Stock-Medication-Reports-Sent-List.js.map
